// @flow
const maskDateInput = function (value: string) {
  let digits = value.replace(/\D/g, '').slice(0, 10)

  if (digits.length >= 4) {
    return `${digits.slice(0, 2)}-${digits.slice(2, 4)}-${digits.slice(4)}`
  } else if (digits.length >= 2) {
    return `${digits.slice(0, 2)}-${digits.slice(2)}`
  }

  return digits
}

export default maskDateInput



// WEBPACK FOOTER //
// ./src/filters/mask-date-input.js